module.exports = __webpack_public_path__ + "static/media/20210411_153800_963_IMG_0484.5fe6dfde.jpg";